
import { supabase } from "@/lib/supabase";

export const setupAdminAccount = async () => {
  try {
    const adminEmail = "hassaanabegam@gmail.com";
    
    console.log("Setting up admin account for:", adminEmail);
    
    // Get current user
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      console.log("No authenticated user found");
      return;
    }
    
    // Check if current user is the admin email
    if (user.email !== adminEmail) {
      console.log("Current user is not the admin email");
      return;
    }
    
    // Ensure profile exists for the admin
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', user.id)
      .maybeSingle();
    
    if (!profile) {
      // Profile doesn't exist, create it
      const { error: createProfileError } = await supabase
        .from('profiles')
        .insert({
          id: user.id,
          full_name: user.user_metadata?.full_name || user.email?.split('@')[0] || 'Hassaana Admin',
          first_name: 'Hassaana',
          last_name: 'Admin',
          avatar_url: user.user_metadata?.avatar_url
        });
      
      if (createProfileError) {
        console.error("Error creating admin profile:", createProfileError);
      } else {
        console.log("Admin profile created successfully");
      }
    }
    
    // Check if user already has admin role
    const { data: existingRole } = await supabase
      .from('user_roles')
      .select('*')
      .eq('user_id', user.id)
      .eq('role', 'admin')
      .maybeSingle();
    
    if (existingRole) {
      console.log("User is already an admin");
      return;
    }
    
    // Add admin role
    const { error: insertError } = await supabase
      .from('user_roles')
      .insert({
        user_id: user.id,
        role: 'admin'
      });
    
    if (insertError) {
      console.error("Error setting user as admin:", insertError);
    } else {
      console.log("Admin setup complete for:", adminEmail);
      
      // Also ensure they have premium access
      await ensurePremiumAccess(user.id);
    }
    
  } catch (error) {
    console.error("Error setting up admin account:", error);
  }
};

// Function to ensure admin has premium access
const ensurePremiumAccess = async (userId: string) => {
  try {
    const endDate = new Date();
    endDate.setFullYear(endDate.getFullYear() + 10); // Give admin 10 years of premium
    
    const { error } = await supabase
      .from('subscribers')
      .upsert({
        user_id: userId,
        email: 'hassaanabegam@gmail.com',
        subscribed: true,
        subscription_end: endDate.toISOString(),
        subscription_tier: 'premium',
        updated_at: new Date().toISOString()
      }, {
        onConflict: 'user_id'
      });
    
    if (error) {
      console.error("Error ensuring premium access:", error);
    } else {
      console.log("Admin premium access ensured");
    }
  } catch (error) {
    console.error("Error ensuring premium access:", error);
  }
};

// Function to check and set admin on user authentication
export const checkAndSetAdminOnAuth = async (userEmail: string, userId: string) => {
  if (userEmail === "hassaanabegam@gmail.com") {
    try {
      console.log("Detected admin user login, setting up admin privileges");
      
      // Check if user already has admin role
      const { data: existingRole } = await supabase
        .from('user_roles')
        .select('*')
        .eq('user_id', userId)
        .eq('role', 'admin')
        .maybeSingle();
      
      if (!existingRole) {
        // Add admin role
        await supabase
          .from('user_roles')
          .insert({
            user_id: userId,
            role: 'admin'
          });
        
        console.log("Admin role assigned to:", userEmail);
      }
      
      // Ensure premium access
      await ensurePremiumAccess(userId);
      
    } catch (error) {
      console.error("Error assigning admin role:", error);
    }
  }
};

// Function to check if current user is admin
export const isCurrentUserAdmin = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user || user.email !== "hassaanabegam@gmail.com") {
      return false;
    }
    
    const { data: role } = await supabase
      .from('user_roles')
      .select('*')
      .eq('user_id', user.id)
      .eq('role', 'admin')
      .maybeSingle();
    
    return !!role;
  } catch (error) {
    console.error("Error checking admin status:", error);
    return false;
  }
};
